var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ad-group-editor" },
    [
      _c("div", { staticClass: "editor-container" }, [
        _c(
          "div",
          { staticClass: "editor-left" },
          [
            _c("div", { staticClass: "section-title" }, [_vm._v("基本信息")]),
            _c("AdGroupForm", {
              ref: "adGroupForm",
              attrs: {
                "is-edit": _vm.isEdit,
                "is-simple-mode": _vm.isSimpleMode,
                "banner-templates": _vm.bannerTemplates,
                "allow-cache": _vm.cacheEnabled,
              },
              on: {
                "template-change": _vm.handleTemplateChange,
                change: _vm.handleFormChange,
              },
              model: {
                value: _vm.form,
                callback: function ($$v) {
                  _vm.form = $$v
                },
                expression: "form",
              },
            }),
            _vm._m(0),
            _c("BannerPosition", {
              ref: "bannerPosition",
              attrs: {
                "slot-keys": _vm.slotKeys,
                "is-edit": _vm.isEdit,
                "is-simple-mode": _vm.isSimpleMode,
                "default-banners": _vm.defaultBanners,
                "allow-cache": _vm.cacheEnabled,
              },
              on: { change: _vm.handleBannerPositionChange },
              model: {
                value: _vm.form,
                callback: function ($$v) {
                  _vm.form = $$v
                },
                expression: "form",
              },
            }),
          ],
          1
        ),
        _vm.form.templateId
          ? _c(
              "div",
              { staticClass: "editor-right" },
              [
                _c("div", { staticClass: "section-title" }, [_vm._v("预览")]),
                _c("BannerPreview", {
                  attrs: { showTitle: false },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "imgSlot",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              { staticClass: "preview-img-container" },
                              [
                                _c("img", {
                                  staticClass: "preview-img",
                                  attrs: {
                                    src: _vm.previewImg,
                                    alt: "Banner预览",
                                  },
                                }),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    3600266044
                  ),
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c("OperationButtons", {
        attrs: {
          "current-index": _vm.$refs.bannerPosition
            ? _vm.$refs.bannerPosition.getCurrentIndex()
            : 0,
          "total-steps": _vm.slotKeys.length,
          "show-save-draft": !_vm.isSimpleMode,
          "is-edit": _vm.isEdit,
          cancelText: _vm.isEdit ? "取消编辑" : "取消新增",
        },
        on: {
          cancel: _vm.handleCancel,
          "save-draft": _vm.saveDraft,
          prev: _vm.handlePrev,
          next: _vm.handleNext,
          submit: _vm.submitForm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "section-title" }, [
      _vm._v("Banner位配置\n        "),
      _c("span", { staticStyle: { color: "red", "font-size": "12px" } }, [
        _vm._v(
          "为每个banner位配置对应内容，所有 banner位配置完成后可以提交审核"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }